import gsap from 'gsap'

class Nav {
  constructor() {
    this.header = document.querySelector('header')
    this.burger = document.querySelector('.burger')
    this.menu = document.querySelector('.menu-fullpage')
    this.panelLeft = document.querySelector('.menu-panel--left')
    this.panelRight = document.querySelector('.menu-panel--right')
    this.links = document.querySelectorAll('.menu-nav a')

    if (!this.burger || !this.header) return

    // État initial
    gsap.set([this.panelLeft, this.panelRight], { opacity: 0 })
    gsap.set(this.links, { opacity: 0 })

    this.isOpen = false
    this.burger.addEventListener('click', () => this.toggle())
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.isOpen = true
    this.header.classList.add('menu-open')
    this.menu.classList.add('is-open')
    document.body.classList.add('overflow')
    document.documentElement.classList.add('overflow')

    const tl = gsap.timeline()

    tl.to([this.panelLeft, this.panelRight], {
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out',
    })

    tl.to(this.links, {
      opacity: 1,
      duration: 0.4,
      stagger: 0.09,
      ease: 'power2.out',
    }, '-=0.2')
  }

  close() {
    this.isOpen = false
    this.header.classList.remove('menu-open')
    document.body.classList.remove('overflow')
    document.documentElement.classList.remove('overflow')

    const tl = gsap.timeline({
      onComplete: () => this.menu.classList.remove('is-open'),
    })

    tl.to(this.links, {
      opacity: 0,
      duration: 0.25,
      ease: 'power2.in',
    })

    tl.to([this.panelLeft, this.panelRight], {
      opacity: 0,
      duration: 0.35,
      ease: 'power2.in',
    }, '-=0.1')
  }
}

export { Nav }
